import { white100 } from 'ext-ui/style/colors'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

// Toast messages render as white text on the highlight-colored toast surface,
// so the message colors are pinned to white rather than the theme font tokens.
export const message = css`
  font-family: ${font_family_weight_regular};
  ${font_md}
  color: ${white100};
`

export const count = css`
  font-family: ${font_family_weight_medium};
  color: ${white100};
`
